import React, { Fragment } from "react";
import { TypingIndicator } from "~/components";
import classNames from "classnames/bind";
import styles from "../../AIChatbot.module.scss";
import ChatMessage from "../ChatMessage";

const cx = classNames.bind(styles);

export default function ChatBody({
  messages,
  isSending,
  chatEndRef,
  chatQuestionsDefault,
  activeMessageId,
  speakingMessageIndex,
  onChatButton,
  onMouseEnter,
  onMouseLeave,
  onMessageClick,
  onCopyMessage,
  onRepeatMessage,
  onTextToSpeech,
  onTypingComplete,
}) {
  return (
    <div className={cx("chat-container__body", "scrollbar")}>
      <div className={cx("chat-content")} ref={chatEndRef}>
        {messages.length > 0 ? (
          <Fragment>
            {messages.map((message, index) => (
              <ChatMessage
                key={index}
                message={message}
                index={index}
                activeMessageId={activeMessageId}
                speakingMessageIndex={speakingMessageIndex}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onMessageClick}
                onCopyMessage={onCopyMessage}
                onRepeatMessage={onRepeatMessage}
                onChatButton={onChatButton}
                onTextToSpeech={onTextToSpeech}
                onTypingComplete={onTypingComplete}
              />
            ))}

            {isSending && (
              <div className="d-flex chat-message pb-4 flex-column">
                <div className={cx("chat-message-content", "fs-8-1")}>
                  <TypingIndicator />
                </div>
              </div>
            )}

            <div style={{ height: "150px" }}></div>
          </Fragment>
        ) : (
          <div style={{ marginTop: "30vh" }}>
            <h4 className="mb-3 text-center">What can I help with?</h4>
            <div className="d-flex justify-content-center">
              <div className={cx("chat-buttons", "d-flex mt-2 mb-2 justify-content-center")}>
                {chatQuestionsDefault.map((question, index) => (
                  <div
                    key={index}
                    title={question}
                    className={cx("chat-button", "fs-8-1 cursor-pointer border")}
                    onClick={() => onChatButton(question, question)}
                  >
                    <span className={cx("button-text", "fs-9 fw-bold")}>{question}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

